// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav, .dropdown-menu {
  background-color: #0e0edb;
}

.dropdown-item:hover {
  background-color: #0b0be9;
  color: white;
  font-weight: bold;
}

a {
  color: rgb(255, 255, 255);
}

.navbar-nav .nav-link.active,
.navbar-brand:hover,
.navbar-nav .nav-link.show,
.navbar-nav .nav-link:hover {
  color: #ffffff;
  font-weight: bold;
}

.navbar-toggler {
  background-color: rgb(0, 0, 0);
  padding: 5px;
}

.navbar-brand:hover {
  color: white;
  font-weight: bold;
  text-shadow: 0px 0px 1px rgb(255, 255, 255);
}

.navbar-brand:focus {
  color: white;
  font-weight: bold;
}

.nav-logo {
  max-height: 60px;
  z-index: 1;
}

@media (min-width: 1385px) {
  .navbar-expand-2xl {
    flex-wrap: nowrap !important;
    justify-content: flex-start !important;
  }
  .navbar-expand-2xl .navbar-collapse {
    display: flex !important;
  }
  .collapse:not(.show) {
    display: none;
  }
  .navbar-expand-2xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-2xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-2xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .navbar-expand-2xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
}
@media (max-width: 1500px) {
  .account-logo {
    display: none !important;
  }
}
@media (max-width: 1385px) {
  .navbar-toggler {
    background-color: rgb(0, 0, 0);
    padding: 15px;
  }
  .navbar-collapse {
    flex-basis: 100%;
    flex-grow: 1;
  }
  .collapse:not(.show) {
    display: none;
  }
  .mobile-spacing {
    margin-bottom: 15px;
    margin-top: 15px;
  }
  .mobile-button {
    padding: 15px;
    font-size: x-large;
  }
  a {
    font-size: x-large;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;;;;EAIE,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,8BAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;EACA,2CAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,UAAA;AACF;;AAGA;EACE;IACE,4BAAA;IACA,sCAAA;EAAF;EAGA;IACE,wBAAA;EADF;EAKA;IACE,aAAA;EAHF;EAMA;IACE,mBAAA;EAJF;EAOA;IACE,aAAA;EALF;EAQA;IACE,kBAAA;EANF;EASA;IACE,2BAAA;EAPF;EAUA;IACE,kDAAA;IACA,iDAAA;EARF;AACF;AAcA;EACE;IACE,wBAAA;EAZF;AACF;AAeA;EAEE;IACE,8BAAA;IACA,aAAA;EAdF;EAiBA;IACE,gBAAA;IACA,YAAA;EAfF;EAkBA;IACE,aAAA;EAhBF;EAmBA;IACE,mBAAA;IACA,gBAAA;EAjBF;EAoBA;IACE,aAAA;IACA,kBAAA;EAlBF;EAqBA;IACE,kBAAA;EAnBF;AACF","sourcesContent":["nav, .dropdown-menu{\n  background-color: #0e0edb;\n}\n\n.dropdown-item:hover {\n  background-color: #0b0be9;\n  color: white;\n  font-weight: bold;\n}\n\na {\n  color: rgb(255, 255, 255);\n}\n\n.navbar-nav .nav-link.active,\n.navbar-brand:hover,\n.navbar-nav .nav-link.show,\n.navbar-nav .nav-link:hover {\n  color: #ffffff;\n  font-weight: bold;\n}\n\n.navbar-toggler {\n  background-color: rgb(0, 0, 0);\n  padding: 5px;\n}\n\n.navbar-brand:hover {\n  color: white;\n  font-weight: bold;\n  text-shadow: 0px 0px 1px rgb(255, 255, 255);\n}\n\n.navbar-brand:focus {\n  color: white;\n  font-weight: bold;\n}\n\n.nav-logo {\n  max-height: 60px;\n  z-index: 1;\n}\n\n//Custom CSS for desktop\n@media (min-width: 1385px) {\n  .navbar-expand-2xl {\n    flex-wrap: nowrap !important;\n    justify-content: flex-start !important;\n  }\n\n  .navbar-expand-2xl .navbar-collapse {\n    display: flex !important;\n    //flex-basis: auto !important;\n  }\n\n  .collapse:not(.show) {\n    display: none;\n  }\n\n  .navbar-expand-2xl .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-2xl .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-expand-2xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .navbar-expand-2xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n\n\n}\n\n//Custom CSS for mobile\n@media (max-width: 1500px) {\n  .account-logo {\n    display: none !important;\n  }\n}\n\n@media (max-width: 1385px) {\n\n  .navbar-toggler{\n    background-color: rgb(0, 0, 0);\n    padding: 15px;\n  }\n\n  .navbar-collapse {\n    flex-basis: 100%;\n    flex-grow: 1;\n  }\n\n  .collapse:not(.show) {\n    display: none;\n  }\n\n  .mobile-spacing {\n    margin-bottom: 15px;\n    margin-top: 15px;\n  }\n\n  .mobile-button {\n    padding: 15px;\n    font-size: x-large;\n  }\n\n  a {\n    font-size: x-large;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
